import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import ButtonAItem from "../core/assets/command/n64Buttons/items/ButtonAItem"
import ButtonCDownItem from "../core/assets/command/n64Buttons/items/ButtonCDownItem"
import ButtonCLeftItem from "../core/assets/command/n64Buttons/items/ButtonCLeftItem"
import ButtonCRightItem from "../core/assets/command/n64Buttons/items/ButtonCRightItem"
import ButtonCUpItem from "../core/assets/command/n64Buttons/items/ButtonCUpItem"
import BoleroOfFire from "./inventory/songs/BoleroOfFire"
import EponaSong from "./inventory/songs/EponaSong"
import MinuetOfForest from "./inventory/songs/MinuetOfForest"
import NocturneOfShadow from "./inventory/songs/NocturneOfShadow"
import PreludeOfLight from "./inventory/songs/PreludeOfLight"
import RequiemOfSpirit from "./inventory/songs/RequiemOfSpirit"
import SariaSong from "./inventory/songs/SariaSong"
import SerenadeOfWater from "./inventory/songs/SerenadeOfWater"
import StormSong from "./inventory/songs/StormSong"
import SunSong from "./inventory/songs/SunSong"
import TimeSong from "./inventory/songs/TimeSong"
import ZeldaLullabySong from "./inventory/songs/ZeldaLullabySong"

interface NoteButtonTrackerProps {
    areNoteShuffle: boolean,
    display: "vertical" | "horizontal" | "double line horizontal"
}

const NoteButtonTracker = (props: NoteButtonTrackerProps) => {

    let { areNoteShuffle } = props;

    let [cUpObtain, setCUpObtain] = useState(!areNoteShuffle);
    let [cDownObtain, setCDownObtain] = useState(!areNoteShuffle);
    let [cLeftObtain, setCLeftObtain] = useState(!areNoteShuffle);
    let [cRightObtain, setCRightObtain] = useState(!areNoteShuffle);
    let [AObtain, setAObtain] = useState(!areNoteShuffle);

    useEffect(() => {

        setCUpObtain(false)
        setCDownObtain(false)
        setCLeftObtain(false)
        setCRightObtain(false)
        setAObtain(false)
    }, [areNoteShuffle])

    // return <Grid container alignContent="flex-start" alignItems={"flex-start"} sx={{ width: props.display === "vertical" ? "50px" : "300px", height: "300px" }} direction="row">
    return <Box display="flex" justifyContent="center" flexDirection={props.display === "vertical" ? "column" : "row"} >
        {
            props.areNoteShuffle &&
            <OcarinaNoteTracker
                AObtain={AObtain}
                cRightObtain={cRightObtain}
                cLeftObtain={cLeftObtain}
                cDownObtain={cDownObtain}
                cUpObtain={cUpObtain}
                setAObtain={setAObtain}
                setCRightObtain={setCRightObtain}
                setCLeftObtain={setCLeftObtain}
                setCDownObtain={setCDownObtain}
                setCUpObtain={setCUpObtain}
                display={props.display}
            />
        }

        <SongTracker
            AObtain={AObtain || !props.areNoteShuffle}
            cRightObtain={cRightObtain || !props.areNoteShuffle}
            cLeftObtain={cLeftObtain || !props.areNoteShuffle}
            cDownObtain={cDownObtain || !props.areNoteShuffle}
            cUpObtain={cUpObtain || !props.areNoteShuffle}
            display={props.display}
        />


    </Box >
}

export default NoteButtonTracker


interface OcarinaNoteTrackerProps {
    setCUpObtain: (v: boolean) => void
    setCLeftObtain: (v: boolean) => void
    setAObtain: (v: boolean) => void
    setCRightObtain: (v: boolean) => void
    setCDownObtain: (v: boolean) => void,
    cUpObtain: boolean,
    cLeftObtain: boolean,
    AObtain: boolean,
    cRightObtain: boolean,
    cDownObtain: boolean,
    display: "horizontal" | "vertical" | "double line horizontal"
}

const OcarinaNoteTracker = (props: OcarinaNoteTrackerProps) => {

    let { setCUpObtain, setCLeftObtain, setAObtain, setCRightObtain, setCDownObtain, cUpObtain, cLeftObtain, AObtain, cRightObtain, cDownObtain } = props;


    return <Box display={"flex"} flexDirection={props.display === "vertical" ? "column" : "row"}>
        <ButtonCLeftItem additionalOnClick={() => setCLeftObtain(!cLeftObtain)} />
        <ButtonCUpItem additionalOnClick={() => setCUpObtain(!cUpObtain)} />
        <ButtonCRightItem additionalOnClick={() => setCRightObtain(!cRightObtain)} />
        <ButtonCDownItem additionalOnClick={() => setCDownObtain(!cDownObtain)} />
        <ButtonAItem additionalOnClick={() => setAObtain(!AObtain)} />
    </Box>
}

interface SongTrackerProps {
    cUpObtain: boolean,
    cLeftObtain: boolean,
    AObtain: boolean,
    cRightObtain: boolean,
    cDownObtain: boolean,
    display: "vertical" | "horizontal" | "double line horizontal"
}

const SongTracker = (props: SongTrackerProps) => {

    let { cUpObtain, cLeftObtain, AObtain, cRightObtain, cDownObtain, display } = props;

    if (display === "vertical")
        return <Box display="flex" flexDirection="column" marginLeft={"5px"}>
            <ZeldaLullabySong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <EponaSong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <SariaSong cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <SunSong cright={cRightObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} />
            <TimeSong a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <StormSong a={AObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} />
            <MinuetOfForest a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <BoleroOfFire a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <SerenadeOfWater a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <RequiemOfSpirit cright={cRightObtain} a={AObtain} cdown={cDownObtain} display={props.display} />
            <NocturneOfShadow a={AObtain} cright={cRightObtain} cdown={cDownObtain} cleft={cLeftObtain} display={props.display} />
            <PreludeOfLight cleft={cLeftObtain} cup={cUpObtain} cright={cRightObtain} display={props.display} />
        </Box>

    if (display === "horizontal")
        return <Box display="flex" flexDirection="row" justifyContent={"space-between"}>
            <ZeldaLullabySong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <EponaSong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <SariaSong cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <SunSong cright={cRightObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} />
            <TimeSong a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <StormSong a={AObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} />
            <MinuetOfForest a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} />
            <BoleroOfFire a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <SerenadeOfWater a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} />
            <RequiemOfSpirit cright={cRightObtain} a={AObtain} cdown={cDownObtain} display={props.display} />
            <NocturneOfShadow a={AObtain} cright={cRightObtain} cdown={cDownObtain} cleft={cLeftObtain} display={props.display} />
            <PreludeOfLight cleft={cLeftObtain} cup={cUpObtain} cright={cRightObtain} display={props.display} />
        </Box>

    //display: double horizontal
    if (display === "double line horizontal")
        return <Box display="flex" flexDirection="column">

            <Box display="flex" flexDirection="row">
                <Box><ZeldaLullabySong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} /></Box>
                <Box><EponaSong cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} /></Box>
                <Box><SariaSong cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><SunSong cright={cRightObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><TimeSong a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><StormSong a={AObtain} cup={cUpObtain} cdown={cDownObtain} display={props.display} /></Box>
            </Box>
            <Box display="flex" flexDirection="row">
                <Box><MinuetOfForest a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cup={cUpObtain} display={props.display} /></Box>
                <Box><BoleroOfFire a={AObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><SerenadeOfWater a={AObtain} cleft={cLeftObtain} cright={cRightObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><RequiemOfSpirit cright={cRightObtain} a={AObtain} cdown={cDownObtain} display={props.display} /></Box>
                <Box><NocturneOfShadow a={AObtain} cright={cRightObtain} cdown={cDownObtain} cleft={cLeftObtain} display={props.display} /></Box>
                <Box><PreludeOfLight cleft={cLeftObtain} cup={cUpObtain} cright={cRightObtain} display={props.display} /></Box>
            </Box>

        </Box>


    return null;
}